export default "__VITE_ASSET__BxvpUSjE__"